import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IRideSoftValidationErrorShiftTimeAlignmentProps } from "../models";

export const RideValidationSoftErrorShiftTimeAlignment: FC<
  IRideSoftValidationErrorShiftTimeAlignmentProps
> = ({ error }) => {
  const { t } = useTranslation();

  return (
    <li>
      {t(`validation.softValidation.${error.type}`, {
        stationName: error.additional?.stationName,
        times: error.additional?.times,
        passengerCombinedInfo: error.additional?.passengerCombinedInfo,
      })}
    </li>
  );
};
